import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiInputNumberFractionComponent } from './fi-input-number-fraction.component';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FiNumberOnlyModule } from '@fi-shared/fi-directives/number-only/number-only.module';

@NgModule({
    imports: [CommonModule, MatInputModule, FormsModule, FiNumberOnlyModule],
    declarations: [FiInputNumberFractionComponent],
    exports: [FiInputNumberFractionComponent],
})
export class FiInputNumberFractionModule {}
